"use client";

import "./hero-banner.scss";
import Image from "next/image";
import { HmcChip } from "@adi-ctx/harmonic-core-components-react";
import t from "@/utils/translate.utils";
import { chips } from "@/lib/constants/herobanner.constants";
import { FilterKeywordSearch, Link } from "@/components";

// Images
import heroIllustration from "/public/assets/illustrations/hero-illustration.svg";
import { pathNames } from "@/lib/constants/pathNames.constants";
import { useState, type ChangeEvent } from "react";
import { useRouter } from "next-nprogress-bar";

export default function HeroBanner() {
	const [isDisabled, setIsDisabled] = useState(false);
	const router = useRouter();
	const titleArray = t("pages.home.hero-banner.title").split(" ");

	const handleOnKeyDown = (
		e: KeyboardEvent & ChangeEvent<HTMLInputElement>
	) => {
		const params = new URLSearchParams();
		params.set("keyword", e.target.value);

		const updatedPath = `${pathNames.search}?${params.toString()}`;

		if (e.key === "Enter") {
			setIsDisabled(true);
			router.push(updatedPath);
		}
	};

	return (
		<div
			className="hero-banner relative w-full py-10"
			data-testid="hero-banner"
		>
			<div className="page-content flex gap-6 px-3 md:p-0">
				<div className="grid grid-cols-1 gap-6 md:grid-cols-2">
					<div
						className="flex flex-1 flex-col"
						data-testid="hero-banner-left-content"
					>
						<h1 className="hmc-title-xl title md:mt-8">
							{titleArray.slice(0, titleArray.length - 1).join(" ")}
							<span className="c-blue-700"> {titleArray.slice(-1)}</span>
						</h1>
						<div className="mt-10 h-[40px]">
							<FilterKeywordSearch
								isDisabled={isDisabled}
								placeholder={t("search.placeholder")}
								onKeyDown={handleOnKeyDown}
							/>
						</div>

						<div
							className="mt-10 flex flex-wrap gap-4"
							data-testid="chipslist-container"
						>
							{chips.map((chip) => {
								return (
									<Link
										key={`chip-${t(chip.title)}-key`}
										href={chip.url}
										data-testid={`chip-${t(chip.title)}-link`}
									>
										<HmcChip
											size="xs"
											hasCheckmark={false}
											className="color-white w-max"
										>
											<Image
												src={`/assets/icons/${chip.icon}`}
												height={16}
												width={16}
												alt={`icon for ${chip.icon}`}
												slot="icon"
												data-testid={`chip-${t(chip.title)}-image`}
											/>
											<span
												className="hmc-subtitle-xs text-black"
												data-testid={`chip-${t(chip.title)}-title`}
											>
												{t(chip.title)}
											</span>
										</HmcChip>
									</Link>
								);
							})}
						</div>
					</div>
					<div
						className="flex hidden md:block"
						data-testid="hero-banner-illustration"
					>
						<Image
							src={heroIllustration}
							alt="hero illustration"
							className="mx-[104px] ml-auto mr-auto md:mr-0"
							width={304}
							height={287}
							loading="eager"
						/>
					</div>
				</div>
			</div>
		</div>
	);
}
